import type { TSidebarItem } from '../../types/ux/sidebarItem.ux.type';
import { AppRoutes } from './appRoutes.mapping';

// #region MENUS PRINCIPALES
export const sidebarItems: TSidebarItem[] = [
  {
    id: 1,
    label: 'Principal',
    icon: 'home',
    link: AppRoutes.home,
  },
  {
    id: 2,
    label: 'Mesa de Servicios',
    icon: 'ticket',
    link: AppRoutes.helpdesk,
  },
  {
    id: 3,
    label: 'Control de Visitas',
    icon: 'user-police',
    link: AppRoutes.scheduledVisits,
  },
  {
    id: 4,
    label: 'Rutas de Fabricación',
    icon: 'route',
    link: AppRoutes.manufacturingRoutes,
  },
  {
    id: 7,
    label: 'Kronos',
    icon: 'users',
    link: AppRoutes.kronos,
    hasPrevDivider: true,
    targetBlank: true,
  },
  {
    id: 8,
    label: 'Tu Recibo',
    icon: 'file-invoice',
    link: AppRoutes.yourReceipt,
    targetBlank: true,
  },
  {
    id: 9,
    label: 'Evaluación de Desempeño',
    icon: 'trophy',
    link: AppRoutes.performanceAssessment,
    targetBlank: true,
  },
];
// #endregion

// #region MENUS HELPDESK | RANGO: 10-99
export const helpDeskItems: TSidebarItem[] = [
  {
    id: 10,
    label: 'Mis Tickets',
    icon: 'ticket',
    link: AppRoutes.myTickets,
  },
  {
    id: 11,
    label: 'Atención de Tickets',
    icon: 'message-bot',
    link: AppRoutes.attendTicket,
  },
  {
    id: 12,
    label: 'Aprobación de Tickets',
    icon: 'check-double',
    link: AppRoutes.approveTicket,
  },
  {
    id: 13,
    label: 'Contactos',
    icon: 'address-book',
    link: AppRoutes.contacts,
  },
];
// #endregion

// #region RUTA DE FABRICACION | MENUS BASE 100
export const creationRoutesItems: TSidebarItem[] = [
  {
    id: 100,
    label: 'Indicadores',
    icon: 'chart-mixed',
    link: AppRoutes.indicators,
  },
  {
    id: 102,
    label: 'Solicitudes Resumen',
    icon: 'memo',
    link: AppRoutes.requestsSumary,
    hasPrevDivider: true,
  },
  {
    id: 103,
    label: 'Solicitudes Generales',
    icon: 'memo',
    link: AppRoutes.requests,
  },
  {
    id: 104,
    label: 'Configuraciones',
    icon: 'gear',
    link: AppRoutes.attendTicket,
    //link: AppRoutes.manufacturingRoutesConfiguration,
  },
  {
    id: 105,
    label: 'Consolidado de Materiales',
    icon: 'chart-line',
    link: AppRoutes.consolidatedMaterials,
    hasPrevDivider: true,
  },
  {
    id: 106,
    label: 'Consolidado de Recetas',
    icon: 'file',
    link: AppRoutes.consolidatedRecipe,
  },
  {
    id: 107,
    label: 'Consolidado de Versiones',
    icon: 'code-fork',
    link: AppRoutes.consolidatedVersion,
  },
  // {
  //   id: 108,
  //   label: 'Fichas de trabajo',
  //   icon: 'file-signature',
  //   link: AppRoutes.manufacturingRoutesSkuSheet,
  //   hasPrevDivider: true,
  // },
];
// #endregion

// #region CONFIGURACIONES | MENUS BASE 200
export const configurationRoutesItems: TSidebarItem[] = [
  {
    id: 201,
    label: 'Tipos de material',
    icon: 'boxes',
    link: AppRoutes.typeMaterials,
  },
  {
    id: 202,
    label: 'Recursos',
    icon: 'tools',
    link: AppRoutes.resources,
    hasDivider: true,
  },
  {
    id: 203,
    label: 'Velocidad de Trefilado',
    icon: 'wind',
    link: AppRoutes.speedTrefilado,
  },
  {
    id: 204,
    label: 'Velocidad de Plastificados',
    icon: 'fill-drip',
    link: AppRoutes.speedPlastificado,
  },
  {
    id: 205,
    label: 'Velocidad de Galvanizado',
    icon: 'bolt',
    link: AppRoutes.speedAlambreGalvanizado,
  },
  {
    id: 206,
    label: 'Velocidad de Varillas',
    icon: 'bars-staggered',
    link: AppRoutes.speedVarilla,
  },
  {
    id: 207,
    label: 'Unidades de Medida',
    icon: 'ruler-combined',
    link: AppRoutes.measureUnits,
  },
];
// #endregion

// #region FICHAS | MENUS BASE 300
export const technicalSheetRoutesItems: TSidebarItem[] = [
  {
    id: 301,
    label: 'Malla Olimpica',
    icon: 'border-all',
    link: AppRoutes.skuMallaOlimpica,
  },
  {
    id: 302,
    label: 'Malla Plastificado',
    icon: 'layer-group',
    link: AppRoutes.skuMallaOlimpicaPlastificada,
  },
];
// #endregion
